import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateDeliverySettings as updateDeliverySettingsApi } from '@/data/api/request/orderDetailsRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Dayjs } from 'dayjs';

type Args = {
  orderId: string;
  deliveryDate?: Dayjs | null;
  deliveryStartTime?: Dayjs;
  deliveryEndTime?: Dayjs;
  deliveryNotes?: string;
};

export function useUpdateDeliverySettings() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const { mutate, isPending, isError } = useMutation({
    mutationFn: (args: Args) =>
      updateDeliverySettingsApi(args.orderId, {
        delivery_date: args.deliveryDate?.format('DD-MM-YYYY') ?? '',
        delivery_time: args.deliveryStartTime?.format('HH:mm') ?? '',
        delivery_time_end: args.deliveryEndTime?.format('HH:mm') ?? '',
        delivery_notes: args.deliveryNotes ?? '',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.detailOrder.details],
      });
      showSnackSuccess('Envío actualizado con exito');
    },
    onError: () => showSnackError('Error al actualizar envío'),
  });

  return {
    updateDeliverySettings: mutate,
    isLoading: isPending,
    isError,
  };
}
